import React from "react";
import { useNavigate } from "react-router-dom";

const RecipeSaveSuccess = () => {
  const navigate = useNavigate();

  const handleRegenerate = () => {
    navigate("/recipe"); //recipe component route
  };

  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center"
      style={{
        backgroundColor: "#fff",
        minHeight: "80vh",
        width: "100%",
      }}
    >
      <div className="mb-3">
        <i
          className="bi bi-arrow-down-circle-fill"
          style={{ fontSize: "3rem", color: "#0096FF" }}
        ></i>
      </div>
      <p className="mb-3 font-weight-bold text-xl">
        Recipe saved in the database successfully
      </p>
      <button
        type="button"
        className="create-button generate-recipe-btn"
        onClick={handleRegenerate}
      >
        Re-generate
      </button>
    </div>
  );
};

export default RecipeSaveSuccess;
